import React from "react";
import { useTranslation } from "react-i18next";
import ButtonComponent from "./ButtonMC";

/**
 * Generic EmptyScreenMC component for empty states.
 *
 * @param {Object} props
 * @param {string} props.title - Translation key for the title.
 * @param {string} props.description - Translation key for the main description.
 * @param {string} [props.description2] - Translation key for the secondary description (optional).
 * @param {string} props.btnLabel - Translation key for the button label.
 * @param {function} [props.onClick] - Handler for the button.
 * @param {string} [props.translationNS] - i18next namespace (default: 'common').
 * @param {string|JSX.Element} [props.image] - Image or icon to display.
 * @param {string} [props.buttonVariant] - Button variant (default: 'SECONDARY').
 * @param {boolean} [props.outlined] - Button outlined style.
 * @param {boolean} [props.tableEmptyScreen] - If true, applies styles for table empty screen (default: false).
 */
const EmptyScreenMC = ({
  title,
  description,
  description2,
  btnLabel,
  onClick,
  translationNS = "Funnels",
  image,
  buttonVariant = "SECONDARY",
  outlined = true,
  tableEmptyScreen = false
}) => {
  const { t } = useTranslation(translationNS);

  return (
    <div className={`tw-wrapper tw-flex tw-flex-row tw-h-full tw-justify-start tw-items-start${tableEmptyScreen ? '' : ' tw-bg-gray-200'}`}>
      <div className={`tw-bg-white tw-rounded-lg${tableEmptyScreen ? '' : ' tw-p-12'} tw-mx-8 tw-w-full tw-my-4${tableEmptyScreen ? '' : ' tw-shadow-sm'}`}>
        <div className="tw-flex tw-items-center tw-gap-4 tw-pl-10 tw-justify-between tw-mx-12 tw-px-12 ">
          <div className={`tw-flex tw-flex-col tw-gap-4 tw-text-justify tw-w-2/3${tableEmptyScreen ? '' : ' tw-max-w-3xl'}`}>
            <div className="tw-flex tw-flex-col tw-gap-1">
              <h2 className="tw-font-medium text-gray-950 !tw-text-base tw-mb-0">
                {t(title)}
              </h2>

              <p className="tw-text-gray-950 tw-mb-0">
                {t(description)}
              </p>

              {description2 && (
                <p className="tw-text-gray-950 tw-mb-0">
                  {t(description2)}
                </p>
              )}
            </div>

            {btnLabel && (
              <div className="">
                <ButtonComponent
                  text={t(btnLabel)}
                  variant={buttonVariant}
                  className="tw-w-64 tw-h-10"
                  iconPosition="right"
                  icon="plus-outline"
                  iconClassName=""
                  onClick={onClick}
                  outlined={outlined}
                />
              </div>
            )}
          </div>

          {image && (
            <div className="tw-px-12 tw-pr-12 tw-w-1/3 tw-flex tw-justify-end">
              <img src={image} alt="EmptyScreen" className="tw-w-64 tw-h-auto tw-object-contain" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmptyScreenMC;
